import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import PropTypes from "prop-types";

import { IconButton, Button } from "@mui/material";
import { Close } from "@mui/icons-material";

import { ReactComponent as IconSuccess } from "../../images/dialogs/success.svg";
import { ReactComponent as IconWarning } from "../../images/iconWarning.svg";
import { ReactComponent as IconError } from "../../images/iconError.svg";
import { ReactComponent as IconInfo } from "../../images/dialogs/info.svg";

const styles = {
  header: {
    minHeight: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "4px",
    padding: "0px 16px",
    boxSizing: "border-box !important",
    width: "100%",
  },
  title: {
    fontFamily: "Nunito",
    fontSize: "26px",
    maxWidth: "calc(100% - 28px)",
    fontWeight: 600,
    lineHeight: "35px",
    color: "white",
    whiteSpace: "normal",
    padding: "0px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  content: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: "24px 16px",
    textAlign: "center",
    borderRadius: "5px",
    gap: "16px",
  },
  body: {
    fontFamily: "Nunito",
    fontSize: "22px",
    fontWeight: 500,
    lineHeight: "30px",
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  textButton: {
    fontFamily: "Nunito",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "25px",
    textTransform: "none",
    padding: "8px 16px",
  },
};

const bgColors = {
  warning: "#FC8618",
  success: "#3AB238",
  error: "#DC3545",
  default: "#1E729F",
};
const colors = {
  warning: "#D56804",
  success: "#178545",
  error: "#8A0202",
  default: "#063F5E",
};
const iconList = {
  warning: <IconWarning width="80px" height="80px" />,
  success: <IconSuccess width="80px" height="80px" />,
  error: <IconError width="80px" height="80px" />,
  default: <IconInfo width="80px" height="80px" />,
};

export default function ModalDialogs({
  open = false,
  onClose,
  onActionPrimary = () => {},
  onActionSecondary = () => {},
  modalType = "warning" | "success" | "error",
  title,
  body,
  secondaryButtonText = "",
  primaryButtonText = "",
  maxWidth = "500px",
}) {
  const bgColor = (bgColors[modalType] || bgColors["default"]) + " !important"; // Cor padrão em caso de tipo inválido
  const color = (colors[modalType] || colors["default"]) + " !important"; // Cor padrão em caso de tipo inválido
  const Icon = iconList[modalType] || null;

  var maxWidthDigits = maxWidth.replace(/\D/g, "");

  maxWidthDigits = Number(maxWidthDigits) + 32;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiPaper-root": {
          maxWidth: `${maxWidthDigits}px`,
        },
      }}
    >
      <Box
        sx={{
          maxWidth: `${maxWidthDigits}px`,
          width: "100%",
          minWidth: "300px",
        }}
      >
        <Box sx={styles.header} bgcolor={bgColor}>
          <DialogTitle sx={styles.title} id="alert-dialog-title">
            {title}
          </DialogTitle>
          <IconButton onClick={onClose}>
            <Close sx={{ color: "whitesmoke" }} />
          </IconButton>
        </Box>

        <DialogContent sx={styles.content}>
          {Icon}

          <DialogContentText
            component="div"
            sx={{ ...styles.body, color: color, width: "100%" }}
            id="alert-dialog-description"
          >
            {body}
          </DialogContentText>
        </DialogContent>

        <DialogActions
          sx={{
            flexWrap: "wrap",
            gap: "8px 0px",
            padding: "0px 16px 16px 16px",
          }}
        >
          {secondaryButtonText !== "" && (
            <Button
              sx={{
                ...styles.textButton,
                border: `1px solid ${bgColor}`,
                color: bgColor,
              }}
              variant="outlined"
              onClick={onActionSecondary}
            >
              {secondaryButtonText}
            </Button>
          )}

          {primaryButtonText !== "" && (
            <Button
              sx={{
                ...styles.textButton,
                border: `1px solid ${bgColor}`,
                color: "white",
                background: bgColor,
              }}
              onClick={onActionPrimary}
            >
              {primaryButtonText}
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}
